// @ts-nocheck
import * as React from 'react';
import { createContext , useState } from "react";
import { useEffect } from "react";
import PropTypes from 'prop-types';
import { PaletteMode, Snackbar } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import AppAppBar from './components/AppAppBar';
import Hero from './components/Hero';
import Footer from './components/Footer';
import getLPTheme from './getLPTheme';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Search from './components/SearchResult';
import SearchDetail from './components/SearchResultDetail';
import Column from './components/Column';
import ColumnDetail from './components/ColumnDetail';
import ColumnManage from './components/ColumnManage';
import MaintenanceNotice from './components/MaintenanceNotice';
import MaintenanceNews from './components/MaintenanceNews';
import MaintenanceSeo from './components/MaintenanceSeo';
import Notification from './components/Notification';
import Sitemap from './components/Sitemap';
import News from './components/News';
import MaintenanceSitemap from './components/MaintenanceSitemap';
import { useTranslation } from 'react-i18next'
import { FormattedMessage, useIntl } from 'react-intl';
import GoogleAnalyticsProvider from './components/GoogleAnalyticsProvider';
import loadAnalytics from './components/googleAnalytics/load-analytics';
 import {
   GoogleReCaptchaProvider,
   GoogleReCaptcha
 } from "react-google-recaptcha-v3";
import Login from './components/';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export const LoginContext = createContext();
export const AuthContext = createContext();
export const LoadingContext = createContext();
export const MsgContext = createContext();
export const MsgOpenContext = createContext();
export const MsgOpenErrContext = createContext();
export const InfoPrewContext = createContext();

interface ToggleCustomThemeProps {
  showCustomTheme: boolean;
  toggleCustomTheme: () => void;
}

window.jQuery = require("jquery");


function ToggleCustomTheme({
  showCustomTheme,
  toggleCustomTheme,
  
}: ToggleCustomThemeProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '100dvw',
        position: 'fixed',
        bottom: 24,
        maxWidth: '100%',
        
      }}
    >
      <ToggleButtonGroup
        color="primary"
        exclusive
        value={showCustomTheme}
        onChange={toggleCustomTheme}
        sx={{
          backgroundColor: 'background.default',
          '& .Mui-selected': {
            pointerEvents: 'none',
          },
        }}
      >
        <ToggleButton value>
          <AutoAwesomeRoundedIcon sx={{ fontSize: '20px', mr: 1 }} />
          Custom theme
        </ToggleButton>
        <ToggleButton value={false}>Material Design 2</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

ToggleCustomTheme.propTypes = {
  showCustomTheme: PropTypes.shape({
    valueOf: PropTypes.func.isRequired,
  }).isRequired,
  toggleCustomTheme: PropTypes.func.isRequired,
};

export default function Default() {
  const [mode, setMode] = React.useState<PaletteMode>('light');
  const [login, setLogin] = React.useState(false);
  const [auth, setAuth] = React.useState(false);
  const [msg, setMsg] = React.useState("langID00001");
  const [msgOpen, setMsgOpen] = React.useState(false);
  const [msgOpenErr, setMsgOpenErr] = React.useState(false);
  const [noticeTitle, setNoticeTitle] = React.useState("");
  const [noticeMsg, setNoticeMsg] = React.useState("");
  const [noticeDate, setNoticeDate] = React.useState("");
  const [noticeMsgOpen, setNoticeMsgOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [data,setData] = React.useState<Post[]>([]);
  const value1 = {
    login,
    setLogin,
  };
  const value3 = {
    auth,
    setAuth,
  };
  const value4 = {
    msg,
    setMsg,
  };
    const value5 = {
    msgOpen,
    setMsgOpen,
  };
      const value6 = {
    msgOpenErr,
    setMsgOpenErr,
  };
      const value2 = {
    loading,
    setLoading,
  };
  const infoPrew = {
    noticeTitle,
    setNoticeTitle,
    noticeMsg,
    setNoticeMsg,
    noticeMsgOpen,
    setNoticeMsgOpen,
    noticeDate,
    setNoticeDate
  };
  const [showCustomTheme] = React.useState(true);
  const LPtheme = createTheme(getLPTheme(mode));
  const defaultTheme = createTheme({ palette: { mode } });
  
  const toggleCgetRandomStringolorMode = (length:num):string => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const result = Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  
  return result;
  };
  
    const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_INSERT_DATA_API_URL;
    try{

   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  const user_id = toggleCgetRandomStringolorMode(16);
  const bodyData = {
    "user_id":user_id,
    "user":""
  };
  setLoading(true);
  return fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
    setLoading(false);
    }catch{
      setLoading(false);
    }
};

  useEffect(() => {
    (async function () {

      const res = await resData();

      setData(res);
      setLoading(false);
    })();
   }, []);
   
  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };
  loadAnalytics()
  
  const [token, setToken] = useState();
  const [score, setScore] = useState();
  const [challengeTime, setChallengeTime] = useState();
  const [themeColor] = useState('dark')

  return (


    <ThemeProvider theme={showCustomTheme ? LPtheme : defaultTheme}>
      <CssBaseline />
      <InfoPrewContext.Provider value={infoPrew}>
      <LoginContext.Provider value={value1}>
      <AuthContext.Provider value={value3}>
      <MsgContext.Provider value={value4}>  
      <MsgOpenContext.Provider value={value5}> 
      <MsgOpenErrContext.Provider value={value6}> 
      <LoadingContext.Provider value={value2}>
      <HelmetProvider>
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode}  />
      <GoogleAnalyticsProvider>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GC_KEY}>
      <Routes>
      <Route  path="/" element={<Hero/>} />
      <Route path="/search" element={<Search/>} />
      <Route path="/searchDetail" element={<SearchDetail/>} />
      <Route path="/column" element={<Column/>} />
      <Route path="/columnDetail" element={<ColumnDetail/>} />
      <Route path="/columnManage" element={<ColumnManage/>} />
      <Route path="/notification" element={<Notification/>} />
      <Route path="/relatedLinks" element={<Sitemap/>} />
      <Route path="/maintenanceNotice" element={<MaintenanceNotice/>} />
      <Route path="/maintenanceSeo" element={<MaintenanceSeo/>} />
      <Route path="/news" element={<News/>} />
      <Route path="/maintenanceNews" element={<MaintenanceNews/>} />
      <Route path="/maintenanceSitemap" element={<MaintenanceSitemap/>} />
      </Routes>
      
      </GoogleReCaptchaProvider>
      </GoogleAnalyticsProvider>
      </HelmetProvider>
      </LoadingContext.Provider>
      </MsgOpenErrContext.Provider>
      </MsgOpenContext.Provider>
      </MsgContext.Provider>
      </AuthContext.Provider>
      </LoginContext.Provider>
      <Box sx={{ bgcolor: 'background.default' }}>
        <Footer />
      </Box>
      </InfoPrewContext.Provider>
    </ThemeProvider>


  );
}
